import React from 'react';

import type { RowType } from 'src/components/PageBuilder/components';
import { useLazyBackgroundImage } from 'src/hooks/useLazyBackgroundImage';

import { getAdvancedSettings } from '../advancedSettings';
import { getBackgroundSettings } from '../backgroundSettings';

import { Row } from './components';

type PageBuilderRowProps = RowType;

/**
 * Return the PB Row Block
 * @param props
 * @constructor
 */
export function PageBuilderRow(props: PageBuilderRowProps) {
    const backgroundId = props.appearance === 'contained' ? `container-${props.uniqueID}` : props.uniqueID;

    useLazyBackgroundImage({ uniqueId: backgroundId || '' });

    /**
     * Configure the styles requires for the Block
     */
    const backgroundStyles = getBackgroundSettings<PageBuilderRowProps>({ ...props });
    const advancedSettings = getAdvancedSettings<PageBuilderRowProps>(props);

    const layoutStyles = {
        minHeight: props.minHeight,
    };

    if (props.verticalAlignment) {
        layoutStyles['display'] = 'flex';
        layoutStyles['flexDirection'] = 'column';
        layoutStyles['justifyContent'] = props.verticalAlignment;
    }

    /**
     * Render the Row Block UI
     */
    return (
        <Row
            styles={{
                ...backgroundStyles,
                ...advancedSettings,
                ...layoutStyles,
            }}
            cssClasses={props.cssClasses}
            appearance={props.appearance ?? 'contained'}
            {...props}
        >
            {props.children}
        </Row>
    );
}
